let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4jRj5")).then(() => parcelRequire('gNcDN'));